import { IconButton } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';

/**
 * A single icon button that triggers the browser's print dialog.
 *
 * `data-action="print"` follows the naming style of this package's other action controls
 * (`view-help`, `view-evidence`, `toggle-capture-playback`): a verb naming what pressing it does.
 * No `data-testid`, per ADR 72: a test selects this button by its accessible name or by
 * `[data-action="print"]`.
 */
export const PrintButton = () => {
  const handlePrint = () => {
    window.print();
  };
  return (
    <IconButton onClick={handlePrint} className="no-print" aria-label="Print" data-action="print">
      <PrintIcon />
    </IconButton>
  );
};
